<div class="monaco-editor" #editorContainer></div>
